import type { Action } from 'redux';
import type { StoredWhitelabelConfig } from '/business/shared/state/actions/whitelabel/setWhitelabelConfig';

export interface WhitelabelState {
  config: StoredWhitelabelConfig | null;
  isSet: boolean;
}

interface SetWhitelabelConfigAction extends Action {
  type: 'SET_WHITELABEL_CONFIG';
  config: StoredWhitelabelConfig;
}

type WhitelabelAction = SetWhitelabelConfigAction;

const defaultState: WhitelabelState = {
  config: null,
  isSet: false,
};

function reducer(state: WhitelabelState = defaultState, action: WhitelabelAction): WhitelabelState {
  switch (action.type) {
    case 'SET_WHITELABEL_CONFIG': {
      return {
        ...state,
        config: action.config,
        isSet: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
